import { render, staticRenderFns } from "./customer-form.vue?vue&type=template&id=6b5e27d4&scoped=true&"
import script from "./customer-form.vue?vue&type=script&lang=js&"
export * from "./customer-form.vue?vue&type=script&lang=js&"
import style0 from "./customer-form.vue?vue&type=style&index=0&id=6b5e27d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5e27d4",
  null
  
)

export default component.exports